export const ASSIGN_OPPORTUNITY_PROSPECT_TO_OPPORTUNITY = `
  mutation AssignOpportunityProspectToOpportunity($opportunityProspectId: ID!, $opportunityId: ID!) {
    assignOpportunityProspectToOpportunity(opportunityProspectId: $opportunityProspectId, opportunityId: $opportunityId){
      opportunity {
        opportunityProspect {
          id
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const ASSIGN_REFERRER_TO_OPPORTUNITY = `
  mutation assignReferrerToOpportunity($referrerId: ID!, $opportunityId: ID!) {
    assignReferrerToOpportunity(referrerId: $referrerId, opportunityId: $opportunityId){
      opportunity {
        referrer {
            id
          }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const ASSIGN_OPPORTUNITY_SOURCE_TO_OPPORTUNITY = `
mutation AssignOpportunitySourceToOpportunity($opportunitySourceId: ID!, $opportunityId: ID!) {
  assignOpportunitySourceToOpportunity(opportunitySourceId:$opportunitySourceId, opportunityId: $opportunityId){
    opportunity {
      opportunitySource {
        id
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const ASSIGN_PHONE_NUMBER_TO_OPPORTUNITY = `
mutation AssignPhoneNumberToOpportunity($phoneNumber: String!, $opportunityId: ID!) {
  assignPhoneToOpportunity(phoneNumber: $phoneNumber, opportunityId: $opportunityId){
    opportunity {
      customer {
        phones {
          number
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const ASSIGN_EMPLOYER_TO_OPPORTUNITY = `
mutation AssignEmployerToOpportunity($opportunityId: ID!, $customerId: ID!, $employerId: ID, $employerName: String, $contactPersonFirstName: String, $contactPersonLastName: String, $contactPersonGender: String, $contactPersonCountryId: ID, $contactPersonRelationship: String, $contactPersonPhoneNumber: String, $contactPersonEmailAddress: String, $newCompany: Boolean!) {
  assignEmployerToOpportunity(opportunityId: $opportunityId, customerId: $customerId, employerId: $employerId, employerName: $employerName, contactPersonFirstName: $contactPersonFirstName, contactPersonLastName: $contactPersonLastName, contactPersonGender: $contactPersonGender, contactPersonCountryId: $contactPersonCountryId, contactPersonRelationship: $contactPersonRelationship, contactPersonPhoneNumber: $contactPersonPhoneNumber, contactPersonEmailAddress: $contactPersonEmailAddress, newCompany: $newCompany){
    opportunity {
      id
      employer
    }
    errors {
      property
      description
    }
  }
}
`;

export const ASSIGN_PRODUCT_TO_OPPORTUNITY = `
mutation AssignProductToOpportunity($productId: ID!, $monthlyExpectedContribution: Float, $lumpsumExpectedContribution: Float, $opportunityId:ID!, $sourceOfAwareness: String, $signupReason: String, $productPaymentType: String, $contributionType: String, $contributionAllocationTypes: [String!], $salesPersonId: ID) {
  assignProductToOpportunity(productId: $productId, monthlyExpectedContribution: $monthlyExpectedContribution, lumpsumExpectedContribution: $lumpsumExpectedContribution, opportunityId: $opportunityId, sourceOfAwareness: $sourceOfAwareness, signupReason: $signupReason, productPaymentType: $productPaymentType,contributionType: $contributionType, contributionAllocationTypes: $contributionAllocationTypes, salesPersonId: $salesPersonId){
    opportunity {
      contributionType
      monthlyExpectedContribution
      lumpsumExpectedContribution
      productPaymentType
      signupReason
      sourceOfAwareness
      product {
        id
      }
      salesPerson {
        id
        name
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const CREATE_OPPORTUNITY_TICKET = `
mutation createOpportunityInteractionTicket($source: String!, $properties: JSON!, $opportunityInteractionId: String! ) {
  createOpportunityInteractionTicket(source: $source, properties: $properties, opportunityInteractionId: $opportunityInteractionId){
    ticket {
      id
      properties
      reference
      source
      url
    }
    errors {
      property
      description
    }
  }
}
`;

export const CONTINUE_OPPORTUNITY = `
  mutation ContinueOpportunity($opportunityId: ID!) {
    continueOpportunity(opportunityId: $opportunityId){
      opportunity {
        id
        state
        newEntity
        contributionType
        productPaymentType
        signupReason
        sourceOfAwareness
        monthlyExpectedContribution
        lumpsumExpectedContribution
        customerSubscriptions {
          id
          product {
            id
            name
          }
          customerBeneficiaries {
            id
            beneficiaryType
            firstName
            middleName
            lastName
            idType {
              id
              name
            }
            idNumber
            dateOfBirth
            benefitsPercentage
            emailAddress
            phoneNumber
            guardianName
            guardianAddress
            guardianPhoneNumber
            guardianEmail
            institutionName
            institutionAddress
            institutionPhoneNumber
            customerRelationship {
              id
              name
            }
          }
          customerSubscriptionTags {
            id
            tag {
              id
              name
            }
          }
        }
        signedApplicationForm {
          id
          url
        }
        directDebitAuthorizationForm {
          id
          url
        }
        vestingRuleDocument {
          id
          url
        }
        npraForm {
          id
          url
        }
        employeeDatasheet {
          id
          url
        }
        opportunityType
        assignee {
          id
          name
        }
        referrer {
          id
          name
        }
        opportunityInteractions {
          id
          description
          interactionDate
          interactionMode {
            id
            name
          }
          createdAt
        }
        preOpportunityInteractions {
          id
          description
          firstName
          lastName
          activityDate
          email {
            id
            address
          }
          interactionSource {
            id
            name
          }
          opportunityProspect {
            id
            name
          }
          phone {
            id
            number
          }
        }
        createdBy {
          id
          name
        }
        progressStatus
        product {
          id
          name
          productTier {
            id
            name
          }
          productCategory {
              id
              name
            }
        }
        opportunitySource {
          id
          name
        }
        opportunityProspect {
          id
          name
        }
        company {
          id
          name
          petraId
          tinNumber
          numberOfEmployees
          companyPayoutAccounts {
            id
            name
            institutionName
            accountNumber
            accountType
            company {
              id
            }
            bankBranch {
              id
              name
              financialInstitution {
                id
                name
              }
            }
          }
          industrySector {
            id
            name
          }
          companyContacts {
            id
            emailAddress
            mobileNumber
            contactName
            mobileNumber
            documentUrl
            role
            contactLevels {
              id
              name
            }
            customer {
              id
              petraId
              ssnitNumber
              dateOfBirth
              fullname
              maritalStatus {
                id
                name
              }
              middleName
              firstName
              gender
              lastName
              country {
                id
                name
              }
              customerEmails {
                id
                email {
                  id
                  address
                }
                isPrimary
                isActive
              }
              activeCustomerPhones {
                id
                phone {
                  id
                  number
                  type
                }
                isPrimary
                isActive
              }
            }
        }
          trustee {
            id
            name
          }
          tags {
            id
            name
          }
          companyAddresses{
            id
            isPrimary
            isActive
            address {
              id
              streetName
              poBox
              ghPost
              region
              city
              isPostalBox
              country {
                id
                name
              }
            }
          }
          companyEmails{
            id
            isPrimary
            isActive
            email {
              id
              address
            }
          }
          companyPhones {
            id
            isPrimary
            isActive
            phone {
              id
              number
              type
            }
          }
          customers {
            id
            petraId
            ssnitNumber
            dateOfBirth
            maritalStatus {
              id
              name
            }
            middleName
            firstName
            gender
            lastName
            country {
              id
              name
            }
            customerAddresses {
              id
              address {
                id
                streetName
                poBox
                ghPost
                region
                city
                isPostalBox

                country {
                  id
                  name
                }
              }
              isPrimary
              isActive
            }
            customerEmails {
              id
              email {
                id
                address
              }
              isPrimary
              isActive
            }
            activeCustomerPhones {
              id
              phone {
                id
                number
                type
              }
              isPrimary
              isActive
            }
          }
          customerCompanyAssociations {
            id
            relationship
            influenceLevel
            dateOfEmployment
            natureOfEmployment
            frequencyOfIncome
            customer {
              id
              petraId
              ssnitNumber
              dateOfBirth
              maritalStatus {
                id
                name
              }
              middleName
              firstName
              gender
              lastName
              country {
                id
                name
              }
              customerAddresses {
                id
                address {
                  id
                  streetName
                  poBox
                  city
                  ghPost
                  region
                  isPostalBox
                  country {
                    id
                    name
                  }
                }
                isPrimary
                isActive
              }
              customerEmails {
                id
                email {
                  id
                  address
                }
                isPrimary
                isActive
              }
              activeCustomerPhones {
                id
                phone {
                  id
                  number
                  type
                }
                isPrimary
                isActive
              }
            }
          }
        }
        customer {
          id
          petraId
          ssnitNumber
          dateOfBirth
          ghanaCardIdUrl
          ghanaCardIdBackUrl
          ghanaCardNo
          idExpiryDate
          idIssueDate
          customerBackgroundInformation{
            fatherName
            fatherDeceased
            fatherPhoneNumber
            motherName
            motherDeceased
            motherPhoneNumber
            previousSsnitNumber
            hometown
            nextOfKinName
            nextOfKinPhoneNumber
            previousEmployer
          }
          maritalStatus {
            id
            name
          }
          middleName
          firstName
          signatureUrl
          idType {
            id
            name
          }
          merged
          photoIdNumber
          photoIdUrl
          tags {
            id
            name
          }
          customerDebitAccounts {
            id
            name
            isVerified
            institutionName
            accountNumber
            accountType
            bankAccountType
            amount
            expirationDate
            authorizationFormUrl
            bankBranch {
              id
              name
              financialInstitution {
                id
                name
              }
            }
          }
          customerPayoutAccounts {
            id
            name
            institutionName
            accountNumber
            accountType
            isPayoutAccountVerified
            payoutAccountVerifiedAt
            customer {
              id
            }
            bankBranch {
              id
              name
              financialInstitution {
                id
                name
              }
            }
          }
          gender
          lastName
          country {
            id
            name
          }
          customerAddresses {
            id
            address {
              id
              streetName
              poBox
              ghPost
              region
              city
              isPostalBox
              country {
                id
                name
              }
            }
            isPrimary
            isActive
          }
          customerEmails {
            id
            email {
              id
              address
            }
            isPrimary
            isActive
          }
          activeCustomerPhones {
            id
            phone {
              id
              number
              type
            }
            isPrimary
            isActive
          }
          }
            }
            errors {
              property
              description
            }
          }
  }
`;

export const ASSIGN_USER_TO_OPPORTUNITY = `
  mutation AssignAssigneeToOpportunity($opportunityId:ID!, $assigneeId: ID! ) {
    assignAssigneeToOpportunity(opportunityId: $opportunityId,  assigneeId: $assigneeId){
      opportunity {
        assignee {
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const CREATE_OPPORTUNITY_INTERACTION = `
  mutation CreateInteraction($opportunityId:ID!, $interactionModeId:ID!,  $userId: ID!, $description: String!, $interactionDate: String ) {
    createOpportunityInteraction(opportunityId: $opportunityId, interactionModeId: $interactionModeId, userId: $userId, description: $description, interactionDate: $interactionDate){
      interactions {
        id
        description
        interactionDate
        interactionMode {
          id
          name
        }
        createdAt
      }
      errors {
          property
          description
      }
    }
  }
`;

export const GET_OPPORTUNITY_CHECKLIST = `
query GetOpportunityOnboardingChecklist($opportunityId: ID!) {
  onboardingChecklist(opportunityId: $opportunityId) {
    percentage
    result {
      message
      status
    }
  }
}`;

export const GET_OPPORTUNITY = `
query GetOpportunity($opportunityId: ID!) {
  opportunity(id: $opportunityId) {
   id
   state
   newEntity
   contributionType
   productPaymentType
   signupReason
   sourceOfAwareness
   monthlyExpectedContribution
   lumpsumExpectedContribution
   notifierRecords {
      id
      notificationType
      status
      message
      recipient
      reference
      createdAt
      updatedAt
      customer {
        id
        petraId
      }
      company {
        id
        petraId
      }
    }
   customerSubscriptions {
    id
    product {
      id
      name
    }
    customerBeneficiaries {
      id
      beneficiaryType
      firstName
      middleName
      lastName
      idType {
        id
        name
      }
      idNumber
      dateOfBirth
      benefitsPercentage
      emailAddress
      isActive
      phoneNumber
      guardianName
      guardianAddress
      guardianPhoneNumber
      guardianEmail
      institutionName
      institutionAddress
      institutionPhoneNumber
      customerRelationship {
        id
        name
      }
    }
    customerSubscriptionTags {
      id
      tag {
        id
        name
      }
    }
  }
  signedApplicationForm {
    id
    url
  }
  directDebitAuthorizationForm {
    id
    url
  }
  vestingRuleDocument {
    id
    url
  }
  npraForm {
    id
    url
  }
  employeeDatasheet {
    id
    url
  }
   opportunityType
   assignee {
     id
     name
   }
   salesPerson {
    id
    name
   }
   companySubscription {
    contributionAllocationTypes
   }
   referrer {
    id
    name
  }
  opportunityInteractions {
    id
    description
    interactionDate
    interactionMode {
      id
      name
    }
    createdAt
  }
  preOpportunityInteractions {
    id
    description
    firstName
    lastName
    activityDate
    email {
      id
      address
    }
    interactionSource {
      id
      name
    }
    opportunityProspect {
      id
      name
    }
    phone {
      id
      number
    }
  }
   createdBy {
     id
    name
  }
  progressStatus
   product {
     id
     name
     productTier {
      id
      name
    }
     productCategory {
        id
        name
      }
   }
   opportunitySource {
     id
     name
   }
   opportunityProspect {
     id
     name
   }
   company {
     id
     name
     petraId
     companySegment
     ssnitNumber
     rocNumber
     tinNumber
     numberOfEmployees
     dateOfEstablishment
     relationshipManager {
       id
       name
     }
     companyPayoutAccounts {
      id
      name
      institutionName
      accountNumber
      accountType
      company {
        id
      }
      bankBranch {
        id
        name
        financialInstitution {
          id
          name
        }
      }
    }
    companyInfoFileUploads {
      id
      url
      fileType
    }
    directors {
      id
      firstName
      lastName
      companies {
        id
        name
      }
      emails {
        address
      }
      phones {
        number
      }
    }
     industrySector {
       id
       name
     }
     trustee {
       id
       name
     }
     tags {
       id
       name
     }
     companyAddresses{
      id
      isPrimary
      isActive
      address {
        id
        streetName
        poBox
        ghPost
        region
        city
        isPostalBox
        country {
          id
          name
        }
      }
    }
    companyEmails{
      id
      isPrimary
      isActive
      email {
        id
        address
      }
    }
    companyPhones {
      id
      isPrimary
      isActive
      phone {
        id
        number
        type
      }
    }
     customers {
      id
      petraId
      ssnitNumber
      dateOfBirth
      maritalStatus {
        id
        name
      }
      middleName
      firstName
      gender
      lastName
      country {
        id
        name
      }
      customerAddresses {
        id
        address {
          id
          streetName
          poBox
          ghPost
          region
          city
          isPostalBox
          country {
            id
            name
          }
        }
        isPrimary
        isActive
      }
      customerEmails {
        id
        email {
          id
          address
        }
        isPrimary
        isActive
      }
      activeCustomerPhones {
        id
        phone {
          id
          number
          type
        }
        isPrimary
        isActive
      }
     }
     companyContacts {
      id
      emailAddress
      mobileNumber
      contactName
      documentUrl
      mobileNumber
      role
      contactLevels {
        id
        name
      }
      customer {
        id
        petraId
        ssnitNumber
        dateOfBirth
        fullname
        maritalStatus {
          id
          name
        }
        middleName
        firstName
        gender
        lastName
        country {
          id
          name
        }
        customerEmails {
          id
          email {
            id
            address
          }
          isPrimary
          isActive
        }
        activeCustomerPhones {
          id
          phone {
            id
            number
            type
          }
          isPrimary
          isActive
        }
      }
  }
   }
   customer {
     id
     petraId
     ssnitNumber
     dateOfBirth
     ghanaCardVerifiedAt
     isDobVerified
     dobVerifiedAt
     verificationProofUrl
     customerBackgroundInformation {
      fatherName
      fatherDeceased
      fatherPhoneNumber
      motherName
      motherDeceased
      motherPhoneNumber
      previousSsnitNumber
      hometown
      nextOfKinName
      nextOfKinPhoneNumber
      previousEmployer
     }
     maritalStatus {
       id
       name
     }
     middleName
     firstName
     signatureUrl
     idType {
       id
       name
     }
     merged
     ghanaCardNo
     ghanaCardIdUrl
     photoIdNumber
     photoIdUrl
     tags {
      id
      name
    }
     customerDebitAccounts {
      id
      name
      isVerified
      institutionName
      accountNumber
      accountType
      bankAccountType
      amount
      expirationDate
      authorizationFormUrl
      bankBranch {
        id
        name
        financialInstitution {
          id
          name
        }
      }
    }
    customerPayoutAccounts {
      id
      name
      institutionName
      accountNumber
      accountType
      isPayoutAccountVerified
      payoutAccountVerifiedAt
      customer {
        id
      }
      bankBranch {
        id
        name
        financialInstitution {
          id
          name
        }
      }
    }
     gender
     lastName
     country {
       id
       name
     }
     customerAddresses {
       id
       address {
         id
         streetName
         poBox
         ghPost
         region
         city
         isPostalBox
         country {
           id
           name
         }
       }
       isPrimary
       isActive
     }
     customerEmails {
       id
       email {
         id
         address
       }
       isPrimary
       isActive
     }
     activeCustomerPhones {
       id
       phone {
         id
         number
         type
       }
       isPrimary
       isActive
     }
     customerInfoFileUploads {
       id
       url
       fileType
     }
   }
  }
 }
`;

export const GET_OPPORTUNITY_CHANGELOG = `
query GetOpportunityChangeLog($opportunityId: ID!) {
  opportunityChangeLogs(opportunityId: $opportunityId) {
    auditItem
    createdAt
    user
    comment
    action
  }
}
`;

export const DELETE_OPPORTUNITY = `
  mutation DeleteOpportunity($id:ID!) {
    deleteOpportunity(id: $id ){
      result
      errors {
        property
        description
      }
    }
  }
`;

export const GET_OPPORTUNITY_FORM_DATA = `
  query   {
    opportunityProspects {
        id
        name
      products {
        id
        name
        productTier {
          id
          name
        }
        productCategory {
          id
          name
        }
      }
    }
  }
`;

export const GET_OPPORTUNITY_PROSPECTS = `
  query {
    opportunityProspects {
      id
      name
    }
  }
`;

export const GET_OPPORTUNITY_NOTIFIER_RECORDS_QUERY = `
query GetOpportunity($opportunityId: ID!) {
  opportunity(id: $opportunityId) {
    notifierRecords {
      id
      notificationType
      status
      message
      recipient
      reference
      createdAt
      updatedAt
      customer {
        id
        petraId
      }
      company {
        id
        petraId
      }
    }
  }
}
`;

export const SEARCH_OPPORTUNITY = `
query SearchOpportunity($q: String, $state: String, $forCurrentUser: Boolean, $page: Int, $numberPerPage: Int, $orderBy: OpportunityOrderByInput) {
  filter(q: $q, state: $state, forCurrentUser: $forCurrentUser,  page: $page, numberPerPage: $numberPerPage, orderBy: $orderBy) {
    count
    results {
      id
      state
      progressStatus
      opportunitySource {
        name
      }
      opportunityType
      opportunityProspect {
        name
      }
      product {
        name
      }
      assignee {
        id
        name
      }
      company {
        id
        name
      }
      customer {
        id
        middleName
        firstName
        lastName
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const GET_OPPORTUNITY_SORT_FIELDS = `
  {
    __type(name: "OpportunitySortFieldEnum") {
      enumValues {
        name
        description
      }
    }
  }
`;

export const OPPORTUNITY_FORM_DATA = `
  query   {
    countries {
      id
      name
      isoCode
    }
    opportunitySources {
      id
      name
    }
    opportunityProspects {
        id
        name
      products {
        id
        name
        productTier {
          id
          name
        }
        productCategory {
          id
          name
        }
      }
    }
  }
`;

export const CREATE_OPPORTUNITY = `
  mutation {
    createOpportunity{
      opportunity {
        id
        state
        newEntity
      }
      errors {
        property
        description
      }
    }
  }
`;
